export enum CUSTOM_HEADER {
    DISABLE_LOADING = 'disable-loading',
    DISABLE_ERROR_HANDLER = 'disable-error-handler'
}